module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/cloud-fog-c6723a571e1a826c39e6e60d6bebd45b.svg";